var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './RangePicker.module.scss';
import { v4 as uuid } from 'uuid';
import { addMonths } from 'date-fns';
import { Calendar } from '../Calendar/Calendar';
import { PickerHeader } from '../PickerHeader/PickerHeader';
import { MonthPicker } from '../MonthPicker/MonthPicker';
var RangePicker = function (_a) {
    var focusDate = _a.focusDate, startDate = _a.startDate, endDate = _a.endDate, startCompareDate = _a.startCompareDate, endCompareDate = _a.endCompareDate, _b = _a.customRange, customRange = _b === void 0 ? '' : _b, months = _a.months, compareable = _a.compareable, minDate = _a.minDate, maxDate = _a.maxDate, compareOn = _a.compareOn, onCompareChange = _a.onCompareChange, onChange = _a.onChange;
    var renderMultiple = function (renderComponent) {
        return Array.from({ length: months || 1 }).map(function (m, i) { return renderComponent(i); });
    };
    var onFocusChange = function (date) {
        var start = compareOn ? startCompareDate : startDate;
        var end = compareOn ? endCompareDate : endDate;
        onChange(date, start, end, customRange);
    };
    var renderCalendar = function (i) { return (_jsx(Calendar, { minDate: minDate, maxDate: maxDate, order: i, startDate: startDate, endDate: endDate, startCompareDate: startCompareDate, endCompareDate: endCompareDate, focusDate: addMonths(focusDate, i), compareOn: compareOn, onCompareChange: onCompareChange, onChange: onChange }, uuid())); };
    return (_jsxs("section", __assign({ className: styles.RangePicker }, { children: [_jsx(PickerHeader, { startDate: startDate, endDate: endDate, startCompareDate: startCompareDate, endCompareDate: endCompareDate, customRange: customRange, compareable: compareable, compareOn: compareOn, onCompareChange: onCompareChange, onChange: onChange }), _jsx(MonthPicker, { minDate: minDate, maxDate: maxDate, months: months, focusDate: focusDate, onChange: onFocusChange }), _jsx("section", __assign({ className: styles.RangeCalendars }, { children: renderMultiple(renderCalendar) }))] })));
};
RangePicker.propTypes = {
    months: PropTypes.number,
    focusDate: PropTypes.instanceOf(Date).isRequired,
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
    startCompareDate: PropTypes.instanceOf(Date).isRequired,
    endCompareDate: PropTypes.instanceOf(Date).isRequired,
    customRange: PropTypes.string.isRequired,
    compareable: PropTypes.bool,
    compareOn: PropTypes.bool.isRequired,
    onCompareChange: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};
export { RangePicker };
//# sourceMappingURL=RangePicker.js.map